let isApiLoaded = false;
let loadingPromise = null;

export const loadGoogleMapsAPI = () => {
  if (isApiLoaded) return Promise.resolve(window.google);

  if (!loadingPromise) {
    loadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        isApiLoaded = true;
        resolve(window.google);
      };
      script.onerror = () => reject(new Error('Google Maps API failed to load.'));
      document.head.appendChild(script);
    });
  }

  return loadingPromise;
};
